import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'docs',
  owner: 'cella',
  scope: ['frontend'],
  description: 'Documentation viewing UI with collaborative editing support.',
});
